import { useState } from 'react';
import { NavLink, Link, Outlet } from 'react-router-dom';
import { useUsuario } from '../../context/UsuarioContext';
import './Layout.css';

const HeartLogo = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 21s-7-4.35-9.5-8.5C.5 9 2 5 5.5 5 8 5 9 7 12 7s4-2 6.5-2C22 5 23.5 9 21.5 12.5 19 16.65 12 21 12 21z" />
    <path d="M9 11h2V9h2v2h2v2h-2v2h-2v-2H9z" />
  </svg>
);

const links = [
  { to: '/', label: 'Inicio', end: true },
  { to: '/buscar', label: 'Buscar turno' },
  { to: '/mis-turnos', label: 'Mis turnos' },
  { to: '/medico/agenda', label: 'Soy médico' },
  { to: '/notificaciones', label: 'Notificaciones' },
  { to: '/componentes', label: 'Guía UI' },
];

export default function Layout() {
  const [abierto, setAbierto] = useState(false);
  const { pacienteId } = useUsuario();

  return (
    <>
      <a className="layout-skip-link" href="#contenido">Saltar al contenido</a>

      <header className="layout-navbar">
        <div className="layout-inner">
          <Link className="layout-brand" to="/">
            <span className="layout-logo"><HeartLogo /></span>
            Sweet Medical
          </Link>

          <button
            className="layout-toggle"
            aria-expanded={abierto}
            aria-controls="menu-principal"
            onClick={() => setAbierto((v) => !v)}
          >
            ☰ Menú
          </button>

          <nav
            id="menu-principal"
            className={`layout-links ${abierto ? 'layout-links-open' : ''}`}
            aria-label="Navegación principal"
          >
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setAbierto(false)}
                className={({ isActive }) => (isActive ? 'layout-active' : undefined)}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main id="contenido" className="layout-page">
        <Outlet />
      </main>

      <footer className="layout-footer">
        <div className="layout-footer-inner">
          <span>Sweet Medical · Entrega 3 · Grupo 05 — DDS UTN FRBA</span>
          {pacienteId && <span className="layout-user-tag">ID activo: {pacienteId}</span>}
        </div>
      </footer>
    </>
  );
}